import React from "react";
import { useGlobalTheme } from "../../../context/GlobalThemeContext";

// useDashboardTheme now reads from GlobalThemeContext — works anywhere in the tree,
// even outside DashboardThemeProvider (which is now a passthrough for compatibility).
export const useDashboardTheme = () => useGlobalTheme();

// Kept for backward compatibility — no longer creates its own context value.
export const DashboardThemeProvider: React.FC<{
  value: boolean;
  children: React.ReactNode;
}> = ({ children }) => <>{children}</>;
